import PromiseRequest from "./PromiseRequest";
import {_} from 'lodash';
import {_d, generateHash} from "../util/misc";
import {TServiceName} from "../constants/ApiServices";
import {nsRequest} from "./fn";
import {IPromiseRequestOptions} from "./index";

export class ConcurrentRequests {
    private store: Record<string, PromiseRequest> = {};
    private counters: Record<string, number> = {};

    private getNumRequests(hash: string): number {
        return this.counters[hash] ?? 0;
    }

    private deltaNumRequests(hash: string, delta: number) {
        if (!this.counters[hash]) {
            this.counters[hash] = 0;
        }
        this.counters[hash] += delta;
    }

    private deleteRequest(hash: string) {
        delete this.store[hash];
        delete this.counters[hash];
    }

    getPromiseRequest(serviceName: TServiceName): PromiseRequest {
        let hash: string;

        const req = new PromiseRequest(serviceName);
        let timeoutId: number
        const facade = {
            request: (params: any = {}, fullResponse: boolean = false, settings: JQuery.AjaxSettings = {}, options?: IPromiseRequestOptions): Promise<any> | any => {
                params = nsRequest.getParams(serviceName, params);
                hash = serviceName + "_" + generateHash(serviceName + JSON.stringify(params) + String(fullResponse));
                if (!this.store[hash]) {
                    this.store[hash] = req;
                }
                // increment the number of concurrent requests
                this.deltaNumRequests(hash, +1);
                clearTimeout(timeoutId)
                timeoutId = setTimeout(() => {
                    const numBefore = this.getNumRequests(hash);
                    if (numBefore > 25) {
                        _d.warn(`High number of concurrent requests (${numBefore}) for`, serviceName);
                    }
                }, 50)
                return this.store[hash]!
                    .request(params, fullResponse, settings, options)
                    .then(data => {
                        this.deltaNumRequests(hash, -1);
                        if (this.getNumRequests(hash) <= 0) {
                            this.deleteRequest(hash);
                        }
                        return data;
                    });
            },
            abort: () => {
                if (this.store[hash]) {
                    // decrement the number of concurrent requests
                    this.deltaNumRequests(hash, -1);
                    // if all requesters have asked for abort we'll comply
                    if (this.getNumRequests(hash) == 0) {
                        return this.store[hash]!.abort();
                        this.deleteRequest(hash);
                    }
                }
            },
        };
        return _.defaults(facade, req);
    }
}
